import {
  PartThumbnailFromUrl,
  PartThumbnailFromUrlProps,
} from './PartThumbnailFromUrl';
import { useMemoryUnsafeCachedObjectUrl } from './hooks/useMemoryUnsafeCachedObjectUrl';

export type PartThumbnailFromCachedBlobProps = Omit<
  PartThumbnailFromUrlProps,
  'thumbnailUrl'
> & {
  thumbnailUrl?: never;
  thumbnailBlob?: Blob | null;
  partFileUuid: string;
};

/**
 * Renders a part thumbnail from props including the thumbnail image as a blob.
 *
 * Uses react query cache to store generated thumbnail urls. Only use this if
 * you have behavior to explicitly revoke urls from memory
 */
export const PartThumbnailFromCachedBlob = ({
  thumbnailBlob,
  partFileUuid,
  ...restProps
}: PartThumbnailFromCachedBlobProps) => {
  const { objectUrl: thumbnailUrl } = useMemoryUnsafeCachedObjectUrl({
    blob: thumbnailBlob,
    key: partFileUuid,
  });

  return <PartThumbnailFromUrl {...restProps} thumbnailUrl={thumbnailUrl} />;
};
